import { NextRouter } from 'next/router';
import { ROUTER_PAGES } from './constants';

export function validateCpf(cpf: string) {
  let isRepeated = true;
  for (let index = 1; index < cpf.length; index++) {
    if (cpf.charAt(0) !== cpf.charAt(index)) {
      isRepeated = false;
      break;
    }
  }
  if (isRepeated) {
    return false;
  }
  if (!cpf || cpf.length === 0) return false;
  if (cpf.length !== 11 || cpf === '00000000000') return false;
  let a = 0;
  for (let i = 1; i <= 9; i++)
    a = a + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  let b = (a * 10) % 11;
  if (b === 10 || b === 11) b = 0;
  if (b !== parseInt(cpf.substring(9, 10))) return false;
  a = 0;
  for (let i = 1; i <= 10; i++)
    a = a + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  b = (a * 10) % 11;
  if (b === 10 || b === 11) b = 0;
  if (b !== parseInt(cpf.substring(10, 11))) return false;
  if (typeof cpf !== 'string' && typeof cpf !== 'number') {
    return false;
  }
  return true;
}

export function validateCnpj(cnpj: string | string[]) {
  if (!cnpj) return false;
  const isString = typeof cnpj === 'string';
  const validTypes = isString || Number.isInteger(cnpj) || Array.isArray(cnpj);
  if (!validTypes) return false;
  const value = cnpj.toString().toUpperCase();
  if (isString) {
    if (value.length > 18) return false;
    const charsOnly = /^[A-Z\d]{12}\d{2}$/.test(value);
    const validFormat =
      /^[A-Z\d]{2}\.[A-Z\d]{3}\.[A-Z\d]{3}\/[A-Z\d]{4}-\d{2}$/.test(value);
    if (charsOnly || validFormat) true;
    else return false;
  }
  const match = value.match(/[A-Z\d]/g);
  // CNPJ alfanumérico: cada caractere vale seu código ASCII menos 48
  const numbers = Array.isArray(match)
    ? match.map(char => char.charCodeAt(0) - 48)
    : [];
  if (numbers.length !== 14) return false;
  if (numbers.slice(12).some(n => n > 9)) return false;
  const items = [...new Set(numbers)];
  if (items.length === 1) return false;
  const calc = (x: number) => {
    const slice = numbers.slice(0, x);
    let factor = x - 7;
    let sum = 0;
    for (let i = x; i >= 1; i--) {
      const n = slice[x - i];
      sum += n * factor--;
      if (factor < 2) factor = 9;
    }
    const result = 11 - (sum % 11);
    return result > 9 ? 0 : result;
  };
  const digits = numbers.slice(12);
  const digit0 = calc(12);
  if (digit0 !== digits[0]) return false;
  const digit1 = calc(13);
  return digit1 === digits[1];
}

export const validateEmailRegex = /^[\w+.-]+@[\w.-]+\.\w{2,3}$/;

export const validateCepRegex = /^\d{5}-?\d{3}$/;

export const validateCnpjRegex =
  /[A-Za-z\d]{2}\.?[A-Za-z\d]{3}\.?[A-Za-z\d]{3}\/?[A-Za-z\d]{4}-?\d{2}/;

/**
 * Validate phone with lib google (libphonenumber)
 */
export const validatePhone = async (number: string) => {
  try {
    const phoneUtil = (
      await import('google-libphonenumber')
    ).PhoneNumberUtil.getInstance();

    return phoneUtil.isValidNumber(phoneUtil.parse(number, 'BR'));
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const hasParamsMarketing = (router: NextRouter): boolean => {
  return (
    !!router?.query.cnpj || !!router?.query.email || !!router?.query.telefone
  );
};

export const hasOnlyLetters =
  /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'˜ˆ` \s]+$/;

export const isAuthenticatedOrFirstAccessPage = (
  isAuthenticatedValue: boolean,
  router: NextRouter
) => {
  return isAuthenticatedValue || router.route === ROUTER_PAGES.primeiroAcesso;
};

export const isIOS = (userAgent: string) =>
  /iPad|iPhone|Macintosh/.test(userAgent);
